document.addEventListener('alpine:init', () => {
    Alpine.data('ajaxCart', () => ({
        loading: false,
        async fetchCart() {
            this.loading = true;
            try {
                const [cart, sections] = await Promise.all([
                    fetch(window.Shopify.routes.root + 'cart.js').then((r) => r.json()),
                    fetch(window.Shopify.routes.root + '?sections=cart-drawer').then((r) => r.json()),
                ]);

                const data = {
                    item_count: cart.item_count,
                    sections: sections,
                };
                this.refreshDrawer(data);
            } finally {
                this.loading = false;
            }
        },

        attachUpsellRuleProps(formData) {
            const ruleEl = document.querySelector('script[data-cart-upsell-rule]');
            if (!ruleEl) return formData;
            try {
                const rule = JSON.parse(ruleEl.textContent);
                if (rule && rule.upsell_handle) {
                    formData.append('properties[_upsell_handle]', rule.upsell_handle);
                    formData.append('properties[_upsell_discount_type]', rule.discount_type || 'none');
                    formData.append('properties[_upsell_discount_value]', String(rule.discount_value || 0));
                    formData.append('properties[_upsell_label]', rule.label || 'You might also like');
                    formData.append('properties[_upsell_subtitle]', rule.subtitle || '');
                    formData.append('properties[_upsell_top_badge]', rule.top_badge || '');
                    formData.append('properties[_upsell_image_url]', rule.upsell_image_url || '');
                }
            } catch (e) {
                console.warn('Cart upsell: failed to parse rule', e);
            }
            return formData;
        },

        async addItem(payload, goToCheckout = false) {
            this.loading = true;
            try {
                // The RBT cards PDP's bundle box (snippets/aba-cards-rbt-bundle.liquid)
                // names the "Complete RBT Bundle" variant in _pf_bundle_variant.
                // Every add button reads #product-form, so swapping the id here
                // covers the main button, the sticky bar and the floating mobile one.
                if (payload instanceof FormData && payload.get('_pf_bundle_variant')) {
                    payload.set('id', payload.get('_pf_bundle_variant'));
                    payload.delete('_pf_bundle_variant');
                }
                let fetchOptions = { method: 'POST' };
                if (payload instanceof FormData) {
                    payload = this.attachUpsellRuleProps(payload);
                    fetchOptions.body = payload;
                } else {
                    fetchOptions.headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
                    fetchOptions.body = JSON.stringify(payload);
                }
                const response = await fetch(window.Shopify.routes.root + 'cart/add.js', fetchOptions);

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.description || errorData.message || 'Something went wrong');
                }

                // ORDER NOW (no cart, 2026-10-23): skip the drawer refresh and go straight to checkout,
                // so the drawer never flashes open before the redirect.
                if (goToCheckout) {
                    window.location.href = window.Shopify.routes.root + 'checkout';
                    return await response.json();
                }
                await this.fetchCart();
                if (window.themeSettings.cartDrawerEnabled && window.themeSettings.openDrawerOnAdd) {
                    this.cartOpen = true;
                }
                return await response.json();
            } catch (error) {
                console.error('Error adding to cart:', error);
                throw error.message;
            } finally {
                this.loading = false;
            }
        },

        async updateQuantity(key, qty) {
            this.loading = true;
            let formData = JSON.stringify({
                id: key,
                quantity: qty,
                sections: 'cart-drawer',
            });

            try {
                const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },
                    body: formData,
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.description || errorData.message || 'Something went wrong');
                }

                const data = await response.json();
                this.refreshDrawer(data);
                return data;
            } catch (error) {
                console.error('Error updating cart:', error);
                throw error.message;
            } finally {
                this.loading = false;
            }
        },

        async removeItem(key) {
            try {
                await this.updateQuantity(key, 0);
            } catch (error) {
                console.error('Error removing item:', error);
            }
        },

        async updateNote(note) {
            this.loading = true;
            let formData = JSON.stringify({
                note: note,
                sections: 'cart-drawer',
            });

            try {
                const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },
                    body: formData,
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.description || errorData.message || 'Something went wrong');
                }

                const data = await response.json();
                this.refreshDrawer(data);
                return data;
            } catch (error) {
                console.error('Error updating note:', error);
                throw error.message;
            } finally {
                this.loading = false;
            }
        },

        refreshDrawer(data) {
            // Update the cart count in header if it exists
            const cartCount = data.item_count;
            if (typeof cartCount !== 'undefined') {
                const cartIconBubble = document.querySelector('#cart-icon-bubble');
                if (cartIconBubble) {
                    let badge = cartIconBubble.querySelector('.cart-badge');
                    if (cartCount > 0) {
                        if (!badge) {
                            badge = document.createElement('span');
                            badge.className = 'cart-badge bg-danger';
                            cartIconBubble.appendChild(badge);
                        }
                        badge.textContent = cartCount;
                    } else if (badge) {
                        badge.remove();
                    }
                }
            }

            if (data.sections && data.sections['cart-drawer']) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(data.sections['cart-drawer'], 'text/html');
                const newDrawer = doc.querySelector('#CartDrawer');
                const currentDrawer = document.querySelector('#CartDrawer');

                if (newDrawer && currentDrawer) {
                    // Replace the inner HTML of the drawer
                    currentDrawer.innerHTML = newDrawer.innerHTML;

                    // Re-initialize Alpine components in the new HTML
                    if (window.Alpine) {
                        window.Alpine.initTree(currentDrawer);
                    }
                }
            }
        },
    }));

    Alpine.data('cartItem', (initialQty, itemKey, inventoryLevel) => ({
        qty: initialQty,
        originalQty: initialQty,
        error: null,
        loading: false,
        timeout: null,
        inventory: inventoryLevel,

        validateQty() {
            if (this.qty < 1) this.qty = 1;
            if (this.qty > this.inventory) this.qty = this.inventory;
        },

        change() {
            this.validateQty();
            this.scheduleUpdate();
        },

        increase() {
            if (this.qty < this.inventory) {
                this.qty++;
                this.scheduleUpdate();
            } else {
                this.error = 'Max available stock reached';
                if (this.errorTimeout) clearTimeout(this.errorTimeout);
                this.errorTimeout = setTimeout(() => {
                    this.error = null;
                }, 3000);
            }
        },

        decrease() {
            if (this.qty > 1) {
                this.qty--;
                this.scheduleUpdate();
            }
        },

        scheduleUpdate() {
            this.error = null;
            if (this.timeout) clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.loading = true;
                this.submit();
            }, 500);
        },

        async submit() {
            try {
                await this.updateQuantity(itemKey, this.qty);
                this.loading = false;
                this.originalQty = this.qty;
                this.error = null;
            } catch (msg) {
                this.loading = false;
                this.qty = this.originalQty;

                let cleanMsg = msg;
                if (msg.toLowerCase().includes('sold out')) cleanMsg = 'Item is sold out';
                if (msg.toLowerCase().includes('cannot add')) cleanMsg = 'Limit reached';

                this.error = cleanMsg;

                // Clear existing timeout if any
                if (this.errorTimeout) clearTimeout(this.errorTimeout);
                this.errorTimeout = setTimeout(() => {
                    this.error = null;
                }, 3000);
            }
        },
    }));
});
